import { TabList } from "@headlessui/react-v2";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import type { ReactNode } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface ListProps {
  children: ReactNode;
  className?: string;
  listClassName?: string;
  underline?: boolean;
}

export const List = ({
  children,
  className = "",
  listClassName = "",
  ...props
}: ListProps) => (
  <OverlayScrollbarsComponent
    className={className}
    options={{
      scrollbars: {
        autoHide: "leave",
        autoHideDelay: 0,
      },
    }}
  >
    <TabList
      as="nav"
      data-testid="tab-list"
      className={classNames("flex gap-6", listClassName)}
      {...props}
    >
      {children}
    </TabList>
  </OverlayScrollbarsComponent>
);

List.displayName = "Tab.List";
